import cx from 'classnames';
import Numeral from 'numeral';

function classForRank(rank: number) {
  if (rank <= 3) {
    return 'text-artifact';
  } else if (rank <= 10) {
    return 'text-legendary';
  } else if (rank <= 100) {
    return 'text-epic';
  } else if (rank <= 10000) {
    return 'text-rare';
  } else if (rank <= 100000) {
    return 'text-uncommon';
  } else {
    return 'text-common';
  }
}

type TGuildRankProps = {
  rank: number;
  className?: string;
  small?: boolean;
  style?: any;
  inheritSize?: boolean;
  feedback?: React.ReactNode;
};

export function GuildRank(props: TGuildRankProps) {
  if (!props.rank) {
    return <>{props.feedback || '-'}</>;
  }

  const sizeClass = props.small ? 'rank-text-small' : 'rank-text-normal';
  const classes = cx(
    props.inheritSize ? '' : sizeClass,
    classForRank(props.rank),
    props.className ? props.className : undefined
  );
  return (
    <span className={classes} style={props.style}>
      {Numeral(props.rank).format('0,0')}
    </span>
  );
}
